import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "card mb-6 mb-xl-9 pt-0 pb-0"
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 d-flex justify-content-start" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", { class: "pb-2 mb-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trophy text-white" }),
  /*#__PURE__*/_createTextVNode("  Machine Rank "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-gray-500" }, "- Top 20 players")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "table-responsive mt-10" }
const _hoisted_12 = {
  key: 0,
  class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4"
}
const _hoisted_13 = { class: "border-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }, "# Rank", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }, "  Player", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-200px" }, null, -1)
const _hoisted_17 = { class: "p-0 w-200px text-end" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-info-circle",
  title: "This time is counted from the launch of the machine until the player picks all the last flag"
}, null, -1)
const _hoisted_19 = {
  key: 0,
  style: {"font-size":"15px"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 1°  ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trophy",
  style: {"color":"#ffd700","font-size":"15px"}
}, null, -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  style: {"font-size":"15px"}
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 2°  ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trophy",
  style: {"color":"#c0c0c0","font-size":"15px"}
}, null, -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 2,
  style: {"font-size":"15px"}
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 3°  ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trophy",
  style: {"color":"#cd7f32","font-size":"15px"}
}, null, -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 3,
  style: {"font-size":"15px"}
}
const _hoisted_32 = ["title"]
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 0,
  title: "Elite Member",
  class: "bi bi-award fs-3 px-1",
  style: {"color":"white"}
}
const _hoisted_35 = { class: "text-muted fw-bold d-block" }
const _hoisted_36 = {
  key: 1,
  class: "fw-bold fs-6 text-gray-500 mb-4"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" First Blood ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-droplet text-danger" }, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "badge badge-light-success" }
const _hoisted_42 = { class: "col-md-6 d-flex justify-content-center" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = {
  class: "pb-2 mb-5",
  title: "Hacker Activity"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-nested text-white" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode("  Hacktivity ")
const _hoisted_47 = { class: "text-gray-500" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = {
  class: "timeline mt-10",
  style: {"max-height":"750px","overflow":"auto"}
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_51 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_52 = { class: "symbol-label bg-light" }
const _hoisted_53 = {
  key: 0,
  class: "bi bi-flag text-success"
}
const _hoisted_54 = {
  key: 1,
  class: "bi bi-flag text-info"
}
const _hoisted_55 = {
  key: 2,
  class: "bi bi-flag text-warning"
}
const _hoisted_56 = {
  key: 3,
  class: "bi bi-flag text-danger"
}
const _hoisted_57 = { class: "timeline-content mb-10 mt-1" }
const _hoisted_58 = { class: "overflow-auto pe-3" }
const _hoisted_59 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_60 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_61 = { class: "text-muted me-2 fs-7" }
const _hoisted_62 = ["title"]
const _hoisted_63 = ["src"]
const _hoisted_64 = /*#__PURE__*/_createTextVNode()
const _hoisted_65 = {
  key: 0,
  title: "Elite Member",
  class: "bi bi-award fs-3 px-1",
  style: {"color":"white"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_ctx.activities)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (
        _ctx.activities?.activities?.length > 0 || _ctx.activities?.scoreboard?.length > 0
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, [
                            (_ctx.activities.scoreboard.length > 0)
                              ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", _hoisted_13, [
                                      _hoisted_14,
                                      _hoisted_15,
                                      _hoisted_16,
                                      _createElementVNode("th", _hoisted_17, [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.time_to_complete`)) + " ", 1),
                                        _hoisted_18
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities.scoreboard, (scoreboard, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        (index + 1 == 1)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_19, _hoisted_22))
                                          : _createCommentVNode("", true),
                                        (index + 1 == 2)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_23, _hoisted_26))
                                          : _createCommentVNode("", true),
                                        (index + 1 == 3)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_27, _hoisted_30))
                                          : _createCommentVNode("", true),
                                        (index + 1 > 3)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_31))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", {
                                            class: "symbol symbol-circle symbol-45px",
                                            "data-bs-toggle": "tooltip",
                                            "data-bs-boundary": "window",
                                            "data-bs-placement": "top",
                                            title: scoreboard.user?.nick
                                          }, [
                                            _createElementVNode("img", {
                                              src: scoreboard.user?.avatar,
                                              alt: "img"
                                            }, null, 8, _hoisted_33)
                                          ], 8, _hoisted_32)
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_RouterLink, {
                                            to: `/profile/user/${scoreboard.user.id}`,
                                            target: "_blank",
                                            class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(scoreboard.user.nick || 'No nick'), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]),
                                          (scoreboard.user.is_elite)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.level`)) + " " + _toDisplayString(scoreboard.user.level), 1),
                                          (index + 1 == 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", {
                                          class: "text-end",
                                          title: _ctx.moment.duration(scoreboard.time_to_complete, 'seconds').format([_ctx.moment.duration(1, 'minute'),_ctx.moment.duration(1, 'day')], 'M [month] w [week] d [day] hh [hour] mm [minute] ss [second]', { trim: 'all' })
                                        }, [
                                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.moment.duration(scoreboard.time_to_complete, 'seconds').format([_ctx.moment.duration(1, "minute"),_ctx.moment.duration(1, "day")], "M[M] w[S] d[d] hh[h] mm[m] ss[s]", { trim: "all" })), 1)
                                        ], 8, _hoisted_40)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("b", _hoisted_44, [
                            _hoisted_45,
                            _hoisted_46,
                            _createElementVNode("small", _hoisted_47, "- " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.last_activities_on_this_machine`)), 1)
                          ]),
                          _hoisted_48,
                          _createElementVNode("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities?.activities, (activity, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "timeline-item",
                                key: index
                              }, [
                                _hoisted_50,
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    (activity.flag.dificulty == 'easy')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_53))
                                      : _createCommentVNode("", true),
                                    (activity.flag.dificulty == 'medium')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_54))
                                      : _createCommentVNode("", true),
                                    (activity.flag.dificulty == 'hard')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_55))
                                      : _createCommentVNode("", true),
                                    (activity.flag.dificulty == 'insane')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_56))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, _toDisplayString(activity.user?.nick || 'No nick') + " " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.picked_up_the_flag`)) + " " + _toDisplayString(activity.flag.dificulty) + " " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.and_won`)) + " " + _toDisplayString(activity.points) + "xp ", 1),
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("div", _hoisted_61, " Owned at " + _toDisplayString(_ctx.moment
                                  .utc(activity.completed_at)
                                  .format("DD/MM/YYYY HH:mm:ss")) + " by ", 1),
                                      _createElementVNode("div", {
                                        class: "symbol symbol-circle symbol-25px d-flex align-items-center",
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-boundary": "window",
                                        "data-bs-placement": "top",
                                        title: activity.user?.nick
                                      }, [
                                        _createElementVNode("img", {
                                          src: activity.user?.avatar,
                                          alt: "img"
                                        }, null, 8, _hoisted_63),
                                        _hoisted_64,
                                        (activity.user.is_elite)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_65))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_62)
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}